// in client side id process.env.NODE_ENV is production then its prodction mode
const DEVELOPMENT_MODE = process.env.NODE_ENV !== 'production';
class Config {
    config = null;
    constructor(){
        try {
            var cnf = document.getElementById('config-server-data').innerText;
            this.config = JSON.parse(cnf);    
        } catch (error) {
            
        }
    }

    get api(){
        let result = ''
        if(this.client_dev_mode) {
            result = process.env.REACT_APP_API_BASE;
        } else {
            result = this.config['API_BASE'];
        }

        return endWithSlash(result);
    }

    get consumerApi() {
        let result = '';
        if(this.client_dev_mode) {
            result = process.env.REACT_APP_CONSUMER_API
        } else {
            result = this.config["CONSUMER_API"];
        }

        return endWithSlash(result);
    }

    get consumerDomainBase() {
        let result = '';
        if(this.client_dev_mode) {
            result = process.env.REACT_APP_CONSUMER_DOMAIN_BASE
        } else {
            result = this.config["CONSUMER_DOMAIN_BASE"];
        }

        return endWithSlash(result);
    }

    get domainRedirect() {
        let result = '';
        if(this.client_dev_mode) {
            result = process.env.REACT_APP_DOMAIN_BASE;
        } else {
            result = this.config["DOMAIN_BASE"];
        }

        return endWithSlash(result);
    }

    get googleMapsKey() {
        if(this.client_dev_mode) {
            return process.env.REACT_APP_GOOGLE_MAPS_KEY
        }

        return this.config["GOOGLE_MAPS_KEY"]
    }

    get brainTreeToken() {
        if(this.client_dev_mode) {
            return process.env.REACT_APP_BRAIN_TREE_TOKEN
        }

        return this.config["RAIN_TREE_TOKEN"]
    }

    get captchaKey() {
        if(this.client_dev_mode) {
            return process.env.REACT_APP_CAPTCHA_KEY
        }

        return this.config["CAPTCHA_KEY"]
    }

    get captchaKeyEnterprise() {
        if(this.client_dev_mode) {
            return process.env.REACT_APP_CAPTCHA_KEY_ENTERPRISE
        }

        return this.config["CAPTCHA_KEY_ENTERPRISE"]
    }

    get createAppointmentClientRoot() {
        return  '/create-appointment';
    }

    get createOrderClientRoot() {
        return  '/create-order';
    }

    get rankingClientRoot() {
        return  '/ranking';
    }

    get static_assets_prefix() {
        return this.client_dev_mode? '/' : '/create-appointment/'
    }

    get createSaleClientRoot() {
        return '/create-sale';
    }

    get googleAutocompleteStartLength() {
        return 3;
    }

    get disableSaveSession() {
        return true
    }

    get cookieAddition () {
        if(this.client_dev_mode) {
            return process.env.COOKIE_ADDITION
        }

        return this.config["COOKIE_ADDITION"]
    }

    get client_env() { 
        if(this.client_dev_mode) 
            return process.env.NODE_ENV
        return this.config["CLIENT_ENV"]
    }

    get client_dev_mode() { 
        return DEVELOPMENT_MODE
    }

    get jwt_key() { 
        if (this.client_dev_mode)
            return process.env.REACT_APP_JWT_KEY
        return this.config.JWT_KEY
    }

    get super_domain() {
        if (this.client_dev_mode)
            return process.env.REACT_APP_SUPER_DOMAIN
        return this.config.SUPER_DOMAIN
    }

    get cookie_domain() {
        if (DEVELOPMENT_MODE) 
            return process.env.REACT_APP_COOKIE_DOMAIN
        return this.config.COOKIE_DOMAIN
    }
}

function endWithSlash(str) {
    let tmp = str;
    if (tmp[tmp.length - 1] !== '/') {
        tmp = tmp + '/' 
    }
    return tmp;
}

export default new Config();